import React, { Component } from 'react';
import './Changelog.css';
import Lightbox from '../utility/Lightbox';
import User from '../../User';
import { isOlderOrEqual } from '../../VersionUpdater';

import changelog from '../../Changelog.json';

export default class Changelog extends Component {

  renderMarkdown(text, keyPrefix) {
    const parts = [];
    const regex = /\[y\](.*?)\[\/y\]/g;

    let lastIndex = 0;
    let match;
    let i = 0;

    while ((match = regex.exec(text)) !== null) {
      if (match.index > lastIndex) {
        parts.push(text.slice(lastIndex, match.index));
      }

      parts.push(
        <span className="yellow" key={`${keyPrefix}-y-${i++}`}>
          {match[1]}
        </span>
      );

      lastIndex = regex.lastIndex;
    }

    if (lastIndex < text.length) {
      parts.push(text.slice(lastIndex));
    }

    return parts;
  }

  renderContentBlock(block, index, version) {
    if (typeof block === 'string') {
      return (
        <p key={`${version}-p-${index}`}>
          {this.renderMarkdown(block, `${version}-p-${index}`)}
        </p>
      );
    }

    if (Array.isArray(block)) {
      return (
        <ul key={`${version}-ul-${index}`}>
          {block.map((item, itemIndex) => (
            <li key={`${version}-li-${index}-${itemIndex}`}>
              {this.renderMarkdown(item, `${version}-li-${index}-${itemIndex}`)}
            </li>
          ))}
        </ul>
      );
    }

    return null;
  }

  render() {
    const manual = this.props.manual;

    const previousVersion =
      localStorage.getItem("changelog.version") || User.getItem("version.previous");
    const version = User.getItem("version");

    const updates = Object.entries(changelog)
      .sort(([version1], [version2]) => {
        if (isOlderOrEqual(version1, version2)) {
          if (isOlderOrEqual(version2, version1)) return 0;
          return -1;
        }
        return 1;
      })
      .filter(([updateVersion]) => {
        if (manual) return true;
        if (!previousVersion) return false;
        return !isOlderOrEqual(updateVersion, previousVersion);
      });

    return (
      <Lightbox
        className="small options-lightbox"
        open={manual || updates.length > 0}
        onClose={() => {
          localStorage.setItem("changelog.version", version);
          this.props.onClose();
        }}
      >
        <div className="options-box">
          <h1>News</h1>

          {updates.slice().reverse().map(([updateVersion, update], index) => (
            <React.Fragment key={updateVersion}>
              <div className="changelog-update">
                {update.title ? <h2>{update.title}</h2> : null}
                <div className="changelog-date">{update.date}</div>
                {(update.text || []).map((block, blockIndex) =>
                  this.renderContentBlock(block, blockIndex, updateVersion)
                )}
              </div>

              {index < updates.length - 1 ? <hr /> : null}
            </React.Fragment>
          ))}
        </div>
      </Lightbox>
    );
  }
}